import { PageSeo } from 'components/orgamisms/SEO';
import BlogPreviewDisplay from 'components/Templates/BlogPreviewDisplay';
import { MiniFooter } from 'components/Templates/Footer';
import NavbarWorkshop from 'components/Templates/NavbarWorkshop';
import { NAVIGATION_ROUTES } from 'constants/navigationPaths';
import siteMetadata from 'constants/siteMetadata';
import useAuth from 'hooks/useAuth';
import { useRouter } from 'next/router';
// import blogposts from 'constants/blogposts';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'react-i18next';
import { tw } from 'utils';
import { getBaseUrl } from 'utils/config';

export default function Blog({ blogposts }) {
  const { t } = useTranslation();
  const { signOut } = useAuth();
  const { push } = useRouter();

  const userNavigation = [
    { label: t('commons.your-profile'), onClick: () => push(NAVIGATION_ROUTES.Settings) },
    { label: t('commons.sign-out'), onClick: signOut }
  ];

  return (
    <>
      <PageSeo
        title={siteMetadata.title}
        description={siteMetadata.description}
        url={`${siteMetadata.siteUrl}/blog`}
      />
      <div className={tw('h-full overflow-hidden')}>
        {/* Content area */}
        <div className={tw('flex-1 flex flex-col overflow-hidden')}>
          <NavbarWorkshop
            logo
            userNavigation={userNavigation}
            customActions={[
              {
                text: t('marketing.blog.editor'),
                onClick: () => push(NAVIGATION_ROUTES.CreateBlog)
              }
            ]}
          />
          {/* Main content */}
          <main className={tw('flex flex-col flex-1 h-full')}>
            <BlogPreviewDisplay blogposts={blogposts} />
          </main>
        </div>

        <MiniFooter />
      </div>
    </>
  );
}

export async function getServerSideProps({ locale }) {
  try {
    const result = await fetch(`${getBaseUrl()}/api/blogs/all`, {
      headers: {
        Accept: 'application/json, text/plain, */*',
        'User-Agent': '*'
      }
    }).then((res) => res.json());

    return {
      props: {
        ...(await serverSideTranslations(locale)),
        // Will be passed to the page component as props
        blogposts: result.data
      }
    };
  } catch (error) {
    console.log('error @blog', error);
    return {
      props: {
        ...(await serverSideTranslations(locale)),
        // Will be passed to the page component as props
        blogposts: []
      }
    };
  }
}
